import React from 'react'
import { async, fromJSX } from 'widgets-for-react'
import { DepartmentOrCentrum, DepartmentOrCentrumOverviewState } from './departmentsAndCentraOverviewState'
import { DepartmentsAndCentraOverviewLayout } from './departmentsAndCentraOverviewLayout'

export const departmentsAndCentraOverviewWidget = (state: DepartmentOrCentrumOverviewState) =>
  async<DepartmentOrCentrum[]>(state, items =>
    fromJSX(() => (
      <DepartmentsAndCentraOverviewLayout
        departmentsAndCentra={items}
        breadcrumbs={[
          { title: 'Spaarne Gasthuis', url: '/' },
          { url: '/afdelingen-en-centra', title: 'Afdelingen en Centra' },
        ]}
      />
    ))
  )
